<span
  class="value-wrapper"
  [ngClass]="{
    'invert-colors': invertColors,
    'negative-value': (value || 0) < 0,
    'positive-value': (value || 0) > 0
  }"
  >
  @if ((value || 0) > 0) {
    <em-icon [size]="'sm'" name="arrow_upward"></em-icon
      >
      }@if ((value || 0) < 0) {
      <em-icon
        [size]="'sm'"
        name="arrow_downward"
      ></em-icon>
    }
    @if ((value || 0) > 0) {
      +
      }{{ displayValue }}
    </span>
